/**
 * @generated SignedSource<<16a5fc368c65ee4acb9af8d116540baa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type RoutineEditOwnerTeamQuery$variables = Record<PropertyKey, never>;
export type RoutineEditOwnerTeamQuery$data = {
  readonly storeViewer: {
    readonly teams: ReadonlyArray<{
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
    }>;
  };
};
export type RoutineEditOwnerTeamQuery = {
  response: RoutineEditOwnerTeamQuery$data;
  variables: RoutineEditOwnerTeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditOwnerTeamQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "StoreViewer",
          "kind": "LinkedField",
          "name": "storeViewer",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "teams",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamSelectList_Team"
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RoutineEditOwnerTeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreViewer",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v4/*: any*/),
              (v1/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "88713622ff62b851f65ed242ae5c003a",
    "id": null,
    "metadata": {},
    "name": "RoutineEditOwnerTeamQuery",
    "operationKind": "query",
    "text": "query RoutineEditOwnerTeamQuery {\n  storeViewer {\n    teams {\n      ...TeamSelectList_Team\n      id\n      color\n      name\n      icon\n      isPrivate\n    }\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n"
  }
};
})();

(node as any).hash = "19c499d6e2e4781fb147c935a672f916";

export default node;
